<template>
<div id="app">
    <header-component></header-component>
    <transition name="fade-transform" mode="out-in">
        <router-view />
    </transition>
    <footer-component></footer-component>
</div>
</template>

<script>
import HeaderComponent from "@/components/Home/Header"
import FooterComponent from "@/components/Home/Footer"
export default {
    name: 'App',
    components: {
        HeaderComponent,
        FooterComponent
    },
    mounted() {
        //插入百度统计排名相关js，重要用来SEO
        let hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?6fa2470fed37eeca8fa5ee7fc613cb93";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-top: 90px;
    overflow-x: hidden;
}

.wrap {
    width: 1250px;
    margin: 0 auto;
}

.centerMsg.el-message {
    top: 50vh;
}
/*fade-transform*/
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
